import { useState } from "react";
import styled from "@emotion/styled";

import Tabs from "components/ui/tabs/Tabs";
import DocumentAiSearch from "./DocumentAiSearch";
import DocumentSearch from "./DocumentSearch";
import { DocumentViewerFilters } from "./FilterForm";

type DocumentSearchTabsProps = {
  documentId: string;
  documentName: string;
  defaultFilters: DocumentViewerFilters;
  isDocumentAiSearchEnabled: boolean;
};

type InnerTabKey = "ai" | "keyword";

export default function DocumentSearchTabs({
  documentId,
  documentName,
  defaultFilters,
  isDocumentAiSearchEnabled,
}: DocumentSearchTabsProps) {
  const [activeInner, setActiveInner] = useState<InnerTabKey>("ai");

  if (!isDocumentAiSearchEnabled) {
    return <DocumentSearch defaultFilters={defaultFilters} documentId={documentId} />;
  }

  return (
    <Container>
      <Tabs
        size="small"
        padding="0 16px"
        value={activeInner}
        onChange={(key) => setActiveInner(key as InnerTabKey)}
        items={[
          {
            key: "ai",
            label: "Ask AI",
            icon: "magicWand",
            children:
              activeInner === "ai" ? (
                <DocumentAiSearch documentId={documentId} documentName={documentName} />
              ) : null,
          },
          {
            key: "keyword",
            label: "Keyword search",
            icon: "searchRefraction",
            children:
              activeInner === "keyword" ? (
                <DocumentSearch defaultFilters={defaultFilters} documentId={documentId} />
              ) : null,
          },
        ]}
      />
    </Container>
  );
}

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
});
